import React from 'react';
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';
import Theme, { ThemeType } from '../../theme';

interface IProps {
  header: string;
  subheader: string;
  headerColor?: string;
  subHeaderColor?: string;
  overrideContainerStyle?: StyleProp<ViewStyle>;
  theme: ThemeType;
}

export const OnBoardingHeader = ({
  header,
  subheader,
  overrideContainerStyle,
  theme = ThemeType.light,
}: IProps) => {
  const color = theme === ThemeType.light ? Theme.CHARCOAL : Theme.WHITE;
  return (
    <View style={[styles.container, overrideContainerStyle]}>
      <Text style={[styles.header, { color }]}>{header.toUpperCase()}</Text>
      <Text style={[styles.subHeader, { color }]}>{subheader}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 20,
  },
  header: {
    fontSize: 20,
    paddingBottom: 5,
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom700,
  },
  subHeader: {
    fontSize: 16,
    lineHeight: 16,
    color: Theme.GREY_DARK,
    fontFamily: Theme.Custom500,
  },
});
